import { BaseRepository } from '@/base/base-repository';
import { APP_CFG } from '@/configs';
import { AuthType } from '@/hooks';
import { getCurrentAuthToken, setCurrentAuthToken } from '@/hooks/auth/utils/auth-token-registry';

export interface CreateAuthTokenPayload {
	address: string;
	authType: NonNullable<AuthType>;
	signature: string;
}

export interface AuthTokenResponse {
	token: string;
}

class AuthRepository extends BaseRepository {
	async createAuthToken(payload: CreateAuthTokenPayload): Promise<AuthTokenResponse> {
		const response = await this.httpClient({
			method: 'post',
			url: '/auth/token',
			data: {
				...payload,
				network: APP_CFG.NETWORK,
			},
		});

		if (response?.token) {
			setCurrentAuthToken(response.token, { silent: true });
		}

		return response;
	}

	async refreshAuthToken(): Promise<AuthTokenResponse> {
		const currentToken = getCurrentAuthToken();
		if (!currentToken) {
			throw new Error('Missing authentication token');
		}

		const response = await this.httpClient({
			method: 'post',
			url: '/auth/token',
			params: { refresh: true },
			headers: {
				Authorization: `Bearer ${currentToken}`,
			},
		});

		if (response?.token) {
			setCurrentAuthToken(response.token, { silent: true });
		}

		return response;
	}

	async invalidateAuthToken(token?: string | null): Promise<void> {
		const currentToken = token ?? getCurrentAuthToken();
		if (!currentToken) {
			return;
		}

		await this.httpClient({
			method: 'post',
			url: '/auth/logout',
			headers: {
				Authorization: `Bearer ${currentToken}`,
			},
		});
	}
}

export const authRepository = new AuthRepository();
